<template>
  <div class="ma-0 pa-0" style="height: 90vh; overflow: hidden">
    <Navigation />
    <v-row class="d-flex justify-end pa-0 ma-0">
      <v-col style="max-width: calc(100% - 56px)">
        <div class="pb-0 mb-0">
          <ToolbarTitles :title="title" class="d-flex flex-wrap mx-auto" />
        </div>
        <div
          class="d-flex flex-wrap justify-space-between my-auto pb-0 mx-auto"
        >
          <data-employed />
          <nav-buttons :title="title" />
        </div>
        <div class="container">
          <TableWithSearch
            :items="getPermissions"
            :headers="allHeaders"
            :openDialog="openDialog"
            :showPagination="false"
            @headersUpdated="updateHeaders"
            @refreshItems="refreshItems"
            :showRefresh="true"
            :asegurable="'accion:modificaretiquetasempleado'"
          />
        </div>
      </v-col>

      <v-dialog
        v-model="open"
        max-width="600px"
        persistent
        @keydown.esc="cancel"
      >
        <v-card max-width="600px">
          <v-card-title
            style="display: flex; justify-content: center"
            class="mb-5"
          >
            {{ mode }}
          </v-card-title>
          <v-alert
            dense
            v-if="error"
            color="red"
            elevation="5"
            outlined
            text
            type="error"
            align="center"
            class="mr-1 ml-1"
          >
            {{ alertValidate }}</v-alert
          >
          <v-form
            @submit.prevent="validation"
            class="ml-5 mr-5"
            ref="form"
            v-model="valid"
          >
            <date-with-check :showCheck="true" class="mb-4" />
            <v-select
              required
              :rules="rules"
              label="Permiso"
              dense
              outlined
              class=""
              v-model="data.permission"
              :items="this.permissions"
              item-value="id"
              item-text="name"
              @change="changePermission"
              :disabled="permissionDisabled"
            />
            <v-select
              required
              :rules="rules"
              label="Segmento"
              dense
              outlined
              class=""
              v-model="data.segment"
              :items="segments"
              item-value="id"
              item-text="name"
              @change="changeSegment"
              :disabled="changePerm"
            />
            <v-text-field
              class=""
              :label="$tc('changeSchedule.sequenceNumber')"
              dense
              outlined
              v-model="data.sequenceNumber"
              disabled
            />

            <v-text-field
              v-model="data.initialDay"
              :label="$tc('changeSchedule.initialDay')"
              outlined
              dense
              type="number"
              :max="initialDay"
              :min="1"
              :disabled="changeSeg"
              :rules="rulesDays"
            />
            <div class="d-flex justify-space-between pb-4">
              <v-btn class="bt-exit" @click="cancel">{{
                $tc("editRegistrations.cancel")
              }}</v-btn>
              <v-btn type="submit" class="bt-acept">
                {{ $tc("editRegistrations.acept") }}</v-btn
              >
            </div>
          </v-form>
        </v-card>
      </v-dialog>
      <DeleteDialog
        :showDialog="openDelete"
        :title="titleDelete"
        :confirmDelete="deleteItem"
        :cancelDelete="cancelDelete"
      />
      <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
      <v-dialog
        v-model="isLoading"
        class="dialog__loader"
        :overlay-opacity="0.3"
      >
        <Loader :loading="isLoading" />
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import schedules from "@/store/permisosDeAcceso/accessPermissions.js";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import DataEmployed from "../../commons/DataEmployed.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import DateWithCheck from "@/components/Complement/DateWithCheck.vue";
import date from "@/store/common/date";
import Loader from "@/components/Complement/Loader.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";
import Navigation from "./Navigation.vue";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import NavButtons from "../../commons/NavButtons.vue";
import moment from "moment";

export default {
  components: {
    DataEmployed,
    Navigation,
    NavButtons,
    ToolbarTitles,
    DateWithCheck,
    TableWithSearch,
    Form,
    DeleteDialog,
    Snackbar,
    Loader,
  },

  data() {
    return {
      showCard: true,
      title: "Permisos",
      titleTable: "Empleados_Permisos",
      color: "",
      titleDelete: "este permiso?",
      isLoading: false,
      headers: [
        {
          text: "Nombre",
          value: "permNombre",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Segmento",
          value: "segmNombre",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Dia de inicio",
          value: "segmDespl",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Fecha desde",
          value: "from",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Fecha hasta",
          value: "to",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      maxWidth: "600px",
      valid: true,
      typeForm: "",
      itemToDelete: null,
      itemId: null,
      alert: false,
      textAlert: "",
      data: {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        permission: null,
      },
      error: false,
      alertValidate: "",
      initialDay: null,
      changeSeg: true,
      changePerm: true,
      itemEdit: null,
      rules: [
        (v) =>
          (v !== null && v !== undefined && v !== "") ||
          this.$tc("editRegistrations.requerid"),
      ],
      rulesDays: [
        (v) =>
          (v !== null && v !== undefined && v !== "" && this.validateDays(v)) ||
          `El número está fuera del rango. El rango válido es de 1 a ${this.initialDay}`,
      ],
      segmentSelected: null,
      permissionSelected: null,
      permissionDisabled: false,
    };
  },

  computed: {
    segments() {
      return schedules.state.permissionSegments;
    },
    permissions() {
      return schedules.state.permissions;
    },
    getPermissions() {
      const items = this.$store.state.permissions.permissions || [];
      const parseDate = (str) => {
        if (!str) return 0;
        const [day, month, year] = str.split("-");
        return new Date(`${year}-${month}-${day}`).getTime();
      };
      return [...items].sort((a, b) => {
        return parseDate(b.from) - parseDate(a.from);
      });
    },
    allHeaders() {
      return configTable.state.colums;
    },
    open: {
      get() {
        return this.$store.state.permissions.open;
      },
      set(value) {
        this.$store.state.permissions.open = value;
      },
    },
    mode: {
      get() {
        return this.$store.state.permissions.mode;
      },
      set(value) {
        this.$store.state.permissions.mode = value;
      },
    },
    openDelete: {
      get() {
        return this.$store.state.permissions.openDelete;
      },
      set(value) {
        this.$store.state.permissions.openDelete = value;
      },
    },
    validInitialDay() {
      return this.initialDay !== null;
    },
    employed() {
      return this.$store.state.employees.itemsEmployed || {};
    },
  },
  mounted() {
    this.$store.dispatch("permissions/getPermissions");
    schedules.dispatch("getPermissions");
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (
          configTable.state.colums.length === 0 ||
          configTable.state.colums.length !== this.headers.length
        ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
  },

  methods: {
    async refreshItems() {
      await this.$store.dispatch("permissions/getPermissions");
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (
        columnsToSave === undefined ||
        this.allHeaders.length !== this.headers.length ||
        columnsToSave.length === 0
      ) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    formatDate(item) {
      const dateToFormat = moment(item, "DD-MM-YYYY");
      let date = dateToFormat.format("YYYY-MM-DD");
      return date;
    },
    saveForm() {
      switch (this.typeForm) {
        case "add":
          this.addPermission();
          break;
        case "edit":
          this.editPermission();
          break;
        default:
          break;
      }
    },
    validation() {
      let valid = this.$refs.form.validate();
      if (valid) {
        this.saveForm();
      } else {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 3000);

        this.alertValidate = this.$tc("editRegistrations.required");
      }
    },
    changeSegment() {
      this.segmentSelected = this.segments.find((segm) => {
        if (segm.id === this.data.segment) {
          return segm;
        }
      });

      this.changeSeg = false;
      this.data.sequenceNumber = this.segmentSelected.numberSequence;
      this.initialDay = this.segmentSelected.days;
      this.data.initialDay = 1;
    },
    changePermission() {
      this.permissionSelected = this.permissions.find((perm) => {
        if (perm.id === this.data.permission) {
          return perm;
        }
      });

      this.changePerm = false;
      schedules.commit("setPermissionId", this.data.permission);
      schedules.dispatch("getSegmentsPermissionId");
    },
    validateDays(value) {
      if (!this.validInitialDay) {
        return true;
      }
      return value >= 1 && value <= this.initialDay;
    },
    cancel() {
      const day = new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10);
      this.$refs.form.resetValidation();
      (this.data = {
        segment: null,
        initialDay: 1,
        sequenceNumber: null,
        permission: null,
      }),
        (this.error = false);
      this.$store.commit("permissions/setOpen", false);
      date.commit("setDateFrom", day);
      date.commit("setDateTo", null);
    },

    async openDialog(type, item) {
      this.alert = false;
      this.typeForm = type;
      switch (this.typeForm) {
        case "add":
          this.$store.commit(
            "permissions/setMode",
            this.$tc("accessPermision.addPermission")
          );
          this.$store.commit("permissions/setOpen", true);
          this.permissionDisabled = false;
          break;
        case "delete":
          this.$store.commit("permissions/setOpenDelete", true);

          this.itemToDelete = {
            empId: Number(localStorage.getItem("empId")),
            permisoId: item.permisoId,
            fecDesde: this.formatDate(item.from),
          };
          break;
        case "edit":
          this.$store.commit(
            "permissions/setMode",
            this.$tc("accessPermision.editPermission")
          );
          this.changePerm = false;
          this.permissionDisabled = true;
          schedules.commit("setPermissionId", item.permisoId);
          schedules.dispatch("getSegmentsPermissionId");
          this.data = {
            permission: item.permisoId,
            segment: item.segmId,
            initialDay: item.segmDespl,
            sequenceNumber: 1,
          };
          date.commit("setDateFrom", this.formatDate(item.from));
          date.commit(
            "setDateTo",
            item.to === " " ? null : this.formatDate(item.to)
          );
          date.commit("setCheckTo", item.to === " " ? true : false);
          this.itemEdit = {
            ...this.data,
            empNombre: this.employed.fullName,
            legajo: this.employed.file,
            from: item.from,
            to: item.to === " " ? null : item.to,
          };
          this.$store.commit("permissions/setOpen", true);
          break;
        default:
          break;
      }
    },
    addPermission() {
      const payload = {
        segmId: this.data.segment,
        permisoId: this.data.permission,
        from: date.state.dateFrom,
        segmDespl: Number(this.data.initialDay),
        emps: [Number(localStorage.getItem("empId"))],
      };
      if (date.state.dateTo !== null) {
        payload.to = date.state.dateTo;
      }
      this.$store.commit("permissions/setNew", payload);
      this.$store
        .dispatch("permissions/new")
        .then(() => {
          this.$store.dispatch("permissions/getPermissions");
          this.alert = true;
          this.textAlert = this.$tc("accessPermision.addPermissionAlert");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancel();
    },
    editPermission() {
      const payload = {
        legajo: this.itemEdit.legajo,
        empNombre: this.itemEdit.empNombre,
        initialDay: this.data.initialDay,
        sequenceNumber: this.data.sequenceNumber,
        permisoId: this.itemEdit.permission,
      };
      if (this.data.segment !== this.itemEdit.segment) {
        payload.segmId = this.data.segment;
        payload.segmNombre = this.segmentSelected.name;
      }
      if (date.state.dateFrom !== this.formatDate(this.itemEdit.from)) {
        payload.from = date.state.dateFrom;
        payload.oldFrom = this.formatDate(this.itemEdit.from);
      } else {
        payload.oldFrom = this.formatDate(this.itemEdit.from);
      }
      if (
        date.state.dateTo !== this.formatDate(this.itemEdit.to) &&
        date.state.dateTo !== null
      ) {
        payload.to = date.state.dateTo;
      }

      this.$store.commit("permissions/setEdit", payload);
      this.$store
        .dispatch("permissions/edit")
        .then(() => {
          this.$store.dispatch("permissions/getPermissions");
          this.alert = true;
          this.textAlert = this.$tc("accessPermision.editPermissionAlert");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancel();
    },
    deleteItem() {
      this.$store.commit("permissions/setDeleteItem", this.itemToDelete);
      this.$store
        .dispatch("permissions/delete")
        .then(() => {
          this.$store.dispatch("permissions/getPermissions");
          this.alert = true;
          this.textAlert = this.$tc("accessPermision.deletePermissionAlert");
          this.color = "#82A1D0";
        })
        .catch((e) => {
          this.alert = true;
          this.textAlert = e.response.data.error.message;
          this.color = "#FF8D58";
        });
      this.cancelDelete();
    },
    cancelDelete() {
      this.$store.commit("permissions/setOpenDelete", false);
    },
  },
};
</script>
<style scoped>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
</style>
